module.exports = __webpack_public_path__ + "img/logo_systec_company.51282581.png";